import React from 'react';
import DesignThinking from 'views/DesignThinking';

const DesktopAppPage = () => {
  return <DesignThinking />;
};

export default DesktopAppPage;
